import React from "react";
import Login from "./Login";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import Home from "../pages/Home.tsx";
import SideMenu from "../nav/SideMenu";
import LandingPage from "../pages/LandingPage.jsx";


const SigninWidget = () => {
  return (
    <div>
      <AuthenticatedTemplate>
        <>
          <LandingPage />
        </>
      </AuthenticatedTemplate>


      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  )
}

export default SigninWidget

